/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { NotificationProvider } from './components/NotificationsProvider';
import React from 'react';
import { ThemeProvider } from '@vaisala/rockhopper-components';
import { ProjectProvider } from './state/project';
import i18n from './i18n';
import { AuthProvider } from './state/auth/AuthContext';
import { UserProvider } from './state/user/UserContext';
import { LidarsProvider } from './state/lidars/LidarsContext';
import { LogbookProvider } from './state/logbook/LogbookContext';

export const Providers = ({ children }: React.PropsWithChildren<{}>) => (
  <BrowserRouter>
    <AuthProvider>
      <UserProvider>
        <LogbookProvider>
        <LidarsProvider>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <NotificationProvider>
            <ProjectProvider>{children}</ProjectProvider>
          </NotificationProvider>
        </ThemeProvider>
      </I18nextProvider>
      </LidarsProvider>
      </LogbookProvider>
      </UserProvider>
    </AuthProvider>
  </BrowserRouter>
);
